import axios from 'axios'
import store from '../store'
// We'll perform local clear on 401 rather than calling logoutUser which redirects

export default function setup () {
	axios.interceptors.request.use(function (config) {
		try {
			const stored = window.localStorage.getItem('token')
			// Normalize stored token: strip any Bearer prefix so we can set a single well-formed header
			const raw = stored && typeof stored === 'string' ? stored.replace(/^Bearer\s+/i, '') : null
			const header = raw ? `Bearer ${raw}` : null

			const tokenUrls = ['generate-token', 'tokenlogout', 'logout']
			let tokenUrlFound = false
			for (let i = 0; i < tokenUrls.length; i++) {
				if (config.url && config.url.indexOf(tokenUrls[i]) !== -1) {
					tokenUrlFound = true
					break
				}
			}

			// if token exists and this request is NOT a token endpoint, attach Authorization header
			if (header && !tokenUrlFound) {
				config.headers = config.headers || {}
				config.headers.Authorization = header

				// Mask token for debug output (don't log full token). Show first/last 4 chars.
				try {
					const t = raw || ''
					const masked = t.length > 8 ? `${t.slice(0,4)}...${t.slice(-4)}` : '****'
					// Use console.debug so these logs can be filtered; remove after debugging.
					console.debug(`Request ${config.method || 'GET'} ${config.url} Authorization=Bearer ${masked}`)
				} catch (e) {}
			}
		} catch (e) {
			// don't block requests on logging errors
		}
		return config
	}, function (err) {
		return Promise.reject(err)
	})

	axios.interceptors.response.use(function (response) {
		store.state.networkError = false
		return response
	}, function (error) {
		store.state.networkError = false
		if (!error.response) {
			console.warn('Network error (no response)')
			store.state.networkError = true
			return Promise.reject(error)
		}

		// Log a short summary for debugging (do not log tokens)
		try {
			console.debug(`Response ${error.config && error.config.url} status=${error.response.status}`)
		} catch (e) {}

		if (error.response.status === 401) {
			// Avoid handling 401 repeatedly (prevent redirect loops)
			if (!store.state.hasLoggedOut) {
				try {
					store.commit('CLEAR_AUTH')
				} catch (e) {}
				try {
					window.localStorage.removeItem('token')
					window.localStorage.removeItem('refreshToken')
					window.localStorage.removeItem('user')
				} catch (e) {}
				store.state.hasLoggedOut = true
				// Redirect to login page once
				try {
					window.location = '/login'
				} catch (e) {}
			} else {
				// Already handled; just reject
			}
		}
		store.state.networkError = false
		return Promise.reject(error)
	})
}
